if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            this.pdpslider();
            this.initTabs(); // specification & description tab
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      pdpslider() {
        setTimeout(() => {

          const mainSwiperEl = this.modalContent.querySelector('[data-main-pdp-swiper]');
          const thumbSwiperEl = this.modalContent.querySelector('.swiprt_thumbnail_slider');

          if (!mainSwiperEl) return;

          const sliderOptions = mainSwiperEl.getAttribute('data-slider-options');
          const slideroptionConfig = JSON.parse(sliderOptions);

          // Destroy existing sliders
          if (mainSwiperEl.swiper) mainSwiperEl.swiper.destroy(true, true);
          if (thumbSwiperEl && thumbSwiperEl.swiper) thumbSwiperEl.swiper.destroy(true, true);

          let thumbSwiperInstance = null;

          // Initialize thumbnail swiper FIRST
          if (thumbSwiperEl) {
            thumbSwiperInstance = new Swiper(thumbSwiperEl, {
              slidesPerView: 4.7,
              spaceBetween: 10,
              watchSlidesProgress: true,
            });
          }

          // Fix pagination
          const pagination = this.modalContent.querySelector('.swiper-pagination');
          if (slideroptionConfig.pagination && pagination) {
            slideroptionConfig.pagination.el = pagination;
          }

          // Attach thumbnail instance to main slider
          if (thumbSwiperInstance) {
            slideroptionConfig.thumbs = {
              swiper: thumbSwiperInstance
            };
          }

          // Initialize main swiper
          new Swiper(mainSwiperEl, slideroptionConfig);

        }, 200);
      }

      initTabs() {
        const tabButtons = this.modalContent.querySelectorAll(".tab-btn");
        const tabContents = this.modalContent.querySelectorAll(".tab-content");

        const setupReadMore = (tab) => {

          const content = tab.querySelector(".read-content");
          const button = tab.querySelector(".read-toggle");

          if (!content || !button) return;

          content.classList.remove("expanded");
          button.style.display = "none";
          console.log(content.scrollHeight);

          if (content.scrollHeight > 100) {
            button.style.display = "inline-flex";
          }

          button.onclick = () => {

            content.classList.toggle("expanded");

            if(content.classList.contains("expanded")){
              button.innerHTML = `
                View Less
                <svg class="toggle-icon" width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z" fill="#000000"/>
                </svg>
              `;
              if(button.closest('.tab-content').getAttribute('id') == 'desc'){
                button.closest('.tab-content').querySelector('.full-desc').style.display = 'block';
                button.closest('.tab-content').querySelector('.trancate-desc').style.display = 'none';
              }
            }else{
              button.innerHTML = `
                View More
                <svg class="toggle-icon" width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z" fill="#000000"/>
                </svg>
              `;
              if(button.closest('.tab-content').getAttribute('id') == 'desc'){
                button.closest('.tab-content').querySelector('.full-desc').style.display = 'none';
                button.closest('.tab-content').querySelector('.trancate-desc').style.display = 'block';
              }
            }
          };

        };

        this.modalContent.querySelectorAll(".tab-content.active").forEach(tab => {
          setupReadMore(tab);
        });

        tabButtons.forEach(btn => {

          btn.addEventListener("click", () => {

            tabButtons.forEach(b => b.classList.remove("active"));
            tabContents.forEach(c => c.classList.remove("active"));

            btn.classList.add("active");

            const tab = this.modalContent.querySelector(`#${btn.dataset.tab}`);
            if (!tab) return;

            tab.classList.add("active");

            setTimeout(() => {
              setupReadMore(tab);
            }, 50);

          });

        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
